import { ReactNode, useCallback, useEffect, useState } from "react";
import { useLocation  } from "react-router";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { getDeviceRoute, getGroupRoute, getRouteFromContext, getRouteFromPath, getTagRoute, getTankBatteryRoute, getTankRoute, getWellRoute } from "../../common/utilities/RouteHelpers";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { IRoute, routes, UIViewCategory } from "../../routes/routes";
import { initViewCategories } from "./RouteHistoryContextUtils";
import useNavigateTo from "../../hooks/use-navigate-to/useNavigateTo";
import storageService from "../../services/storage/storage-service/StorageService";
import { StorageKeys } from "../../services/storage/StorageKeys";
import { RouteHistoryContext } from "./RouteHistoryContext";

export type RouteHistoryContextProviderProps = {
    children: ReactNode;
};

export function RouteHistoryContextProvider({ children }: RouteHistoryContextProviderProps) {

    const location = useLocation();
    const routeContext = useRouteContext();
    const [routeHistory, setRouteHistory] = useState<IRoute[]>([]);
    const navigateTo = useNavigateTo();

    // const path = useRef<string>(location.pathname);

    useEffect(() => {

        // store the route in local storage so when if the OS unloads the app, as is apparently the 
        // case on android phones, the user will be logged back into the app and routed to the last
        // view they were on
        const currentRoute = getRouteFromPath(location.pathname);
        if (currentRoute && currentRoute.viewID !== UIViewEnum.Login) {
            storageService.local.set(StorageKeys.RedirectRestorePath, `${location.pathname}${location.search}`);
        }
    }, [
        location.pathname,
        location.search
    ]);

    useEffect(() => {

        if (routeHistory.length === 0) {

            const currentRoute = getRouteFromPath(location.pathname);
            let newRouteHistory: IRoute[] = [];

            if (routeContext.contextObject &&
                currentRoute /*&& currentRoute.category !== UIViewCategory.AdminGroup*/) {

                // add to the route history
                newRouteHistory.push(currentRoute);

                // get route history view categories for the current context
                const categories = initViewCategories(routeContext);

                // in case of F5 refresh or reload, make sure there is a previous route to return to when needed.
                categories.forEach((o) => {
                    if (!newRouteHistory.find(v => v.category === o)) {
                        // pick the first available route.  May need to explicitly set one
                        newRouteHistory.push(routes.find(v => v.category === o) as IRoute);
                    }
                });

                // filter any out that are no longer valid
                newRouteHistory = categories.reduce((result: IRoute[], currentValue) => {
                    return result.concat(newRouteHistory.filter(o => o.category === currentValue));
                }, []);

                setRouteHistory(newRouteHistory);
            }
        }
    }, [
        routeContext,
        location.pathname,
        routeHistory,
        setRouteHistory
    ]);

    useEffect(() => {

        setRouteHistory(prevRouteHistory => {

            const currentRoute = getRouteFromPath(location.pathname);
            console.log(`You changed the page to: ${currentRoute?.fullPath} category: ${currentRoute?.category}`);

            let newRouteHistory = [...prevRouteHistory];


            if (currentRoute /*&& currentRoute.category !== UIViewCategory.AdminGroup*/) {

                const ndx = prevRouteHistory.findIndex(o => o.category === currentRoute.category);
                if (ndx !== -1) {
                    // replace item in the array
                    newRouteHistory[ndx] = currentRoute;

                } else {
                    // add to the route history
                    newRouteHistory.push(currentRoute);
                }

                // user has chosen to go back, therefore, filter out history that is no longer relevant
                switch (currentRoute.category) {

                    case UIViewCategory.TankBattery:
                        newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag && o.category !== UIViewCategory.Tank);
                        break;

                    case UIViewCategory.Well:
                        newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag && o.category !== UIViewCategory.Tank && o.category !== UIViewCategory.Device);
                        break;

                    case UIViewCategory.Device:
                        newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag && o.category !== UIViewCategory.Tank);
                        break;

                    case UIViewCategory.Tank:
                        newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag);
                        break;

                    case UIViewCategory.AdminGroup:
                        newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.AdminView);
                        break;

                    default:
                        // nothing to do for Group or Tag
                        break;
                }

                return newRouteHistory;
            }

            return prevRouteHistory;
        });
    }, [
        //history,
        location.pathname,
        //navigate,
        //routeHistory,
        setRouteHistory
    ]);







    // useEffect(() => {

    //     if (location.pathname !== path.current) {
    //         // when the route changes, update the internal route history
    //         //return history.listen((update) => { 

    //         const currentRoute = getRouteFromPath(location.pathname);
    //         console.log(`You changed the page to: ${currentRoute?.fullPath} category: ${currentRoute?.category}`);

    //         let newRouteHistory = [...routeHistory];


    //         if (currentRoute /*&& currentRoute.category !== UIViewCategory.AdminGroup*/) {

    //             const ndx = routeHistory.findIndex(o => o.category === currentRoute.category);
    //             if (ndx !== -1) {
    //                 // replace item in the array
    //                 newRouteHistory[ndx] = currentRoute;

    //             } else {
    //                 // add to the route history
    //                 newRouteHistory.push(currentRoute);
    //             }

    //             // user has chosen to go back, therefore, filter out history that is no longer relevant
    //             switch (currentRoute.category) {

    //                 case UIViewCategory.TankBattery:
    //                     newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag && o.category !== UIViewCategory.Tank);
    //                     break;

    //                 case UIViewCategory.Well:
    //                     newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag && o.category !== UIViewCategory.Tank && o.category !== UIViewCategory.Device);
    //                     break;

    //                 case UIViewCategory.Device:
    //                     newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag && o.category !== UIViewCategory.Tank);
    //                     break;

    //                 case UIViewCategory.Tank:
    //                     newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.Tag);
    //                     break;

    //                 case UIViewCategory.AdminGroup:
    //                     newRouteHistory = newRouteHistory.filter(o => o.category !== UIViewCategory.AdminView);
    //                     break;

    //                 default:
    //                     // nothing to do for Group or Tag
    //                     break;
    //             }

    //             setRouteHistory(newRouteHistory);
    //         }
    //         //}) 
    //         path.current = location.pathname;
    //     }

    // }, [
    //     //history,
    //     location.pathname,
    //     navigate,
    //     routeHistory,
    //     setRouteHistory
    // ]);


    const goBack = useCallback(() => {

        const routes = routeHistory.slice(0, -1);

        if (routes.length) {
            const previous = routes[routes.length - 1];

            let url: string | undefined;
            switch (previous?.category) {
                case UIViewCategory.Group:
                    url = getGroupRoute(previous.viewID as UIViewEnum, routeContext.groupID as number);
                    break;

                case UIViewCategory.Well:
                    url = getWellRoute(previous.viewID as UIViewEnum, routeContext.groupID, routeContext.wellID);
                    break;

                case UIViewCategory.Device:
                    url = getDeviceRoute(previous.viewID as UIViewEnum, routeContext.groupID, routeContext.wellID, routeContext.deviceID);
                    break;

                case UIViewCategory.Tank:
                    url = getTankRoute(previous.viewID as UIViewEnum, routeContext.groupID, routeContext.deviceID, routeContext.tankBatteryID, routeContext.tankID);
                    break;

                case UIViewCategory.TankBattery:
                    url = getTankBatteryRoute(previous.viewID as UIViewEnum, routeContext.groupID, routeContext.tankBatteryID);
                    break;

                case UIViewCategory.AdminGroup:
                    url = getRouteFromContext(previous.viewID as UIViewEnum, routeContext);
                    break;

                case UIViewCategory.Tag:
                    url = getTagRoute(previous.viewID as UIViewEnum,
                        routeContext.groupID,
                        routeContext.wellID,
                        routeContext.deviceID,
                        routeContext.tankBatteryID,
                        routeContext.tankID,
                        routeContext.tagID);
                    break;

                default:
                    break;

            }

            if (url) {
                navigateTo(url);
            }
        }

        setRouteHistory(routes);

    }, [
        navigateTo,
        routeContext,
        routeHistory,
        setRouteHistory
    ]);

    //console.log(`myroutehistory: ${JSON.stringify(myrouteHistory)}`);

    // console.log("========== Rendering RouteContextProvider ==========");
    return (
        <RouteHistoryContext.Provider value={[routeHistory, goBack]}>
            {children}
        </RouteHistoryContext.Provider>
    );
}